import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskedLines, FadeIn } from "@/components/Reveal";

export const PageHero = ({ eyebrow, lines, sub, image }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

  return (
    <section ref={ref} className="relative flex min-h-[68vh] items-end overflow-hidden pt-20" data-testid="page-hero">
      <motion.div style={{ y }} className="absolute inset-0 -bottom-[25%]">
        <img src={image} alt="" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-trx-black via-transparent to-black/40" />
      <div className="absolute inset-0 spotlight" />

      <div className="relative mx-auto w-full max-w-[1600px] px-6 pb-20 md:px-10 md:pb-28">
        <FadeIn delay={0.3}>
          <p className="eyebrow mb-6 text-trx-blue">{eyebrow}</p>
        </FadeIn>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-black leading-[0.95] tracking-tighter text-white">
          <MaskedLines lines={lines} delay={0.15} />
        </h1>
        {sub && (
          <FadeIn delay={0.8}>
            <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-zinc-400">{sub}</p>
          </FadeIn>
        )}
      </div>
    </section>
  );
};
